<template>
  <div>
    <el-upload
      ref="uploader"
      :list-type="ComputedListType"
      action="#"
      :auto-upload="true"
      :limit="limit === 1 ? limit + 1 : limit"
      :before-upload="beforeUploadHandle"
      :on-exceed="onExceedHandle"
      :http-request="uploadRequestHandle"
      :file-list="fileListResult"
      :on-remove="handleRemove"
      :show-file-list="showFileList"
      :on-change="fileChangeHandle"
      :disabled="disabled"
      class="uploader"
      :class="{
        'exceed-limit': fileListResult.length >= limit
      }"
    >
      <template v-slot:default>
        <slot name="trigger" :fileListResult="limit > 1 ? fileListResult : singleFileUpload">
          <template v-if="limit > 1">
            <el-button v-if="ComputedListType === 'text'" type="primary">
              上传文件 +
            </el-button>
            <i v-else class="el-icon-plus" />
          </template>
          <template v-else>
            <el-button v-if="ComputedListType === 'text'" type="primary">
              上传文件 +
            </el-button>
            <div v-else class="single-pic-show" :style="{ cursor: disabled ? 'not-allowed' : 'pointer' }">
              <img v-if="singleFileUpload" :src="singleFileUpload.url">
              <div v-if="!disabled" class="trigger-icon-box">
                <i class="el-icon-plus" style="font-size: 40px;color: #b6b6b6;" />
              </div>
              <el-progress v-if="singleFileUpload && filePercentage[singleFileUpload.uid] < 100" style="top: -12px; rgb(255 255 255 / 0.6);" :type="'line'" :percentage="filePercentage[singleFileUpload.uid]" />
            </div>
          </template>
        </slot>
      </template>
      <div slot="file" slot-scope="{file}" style="height: 100%;">
        <slot name="file-view" :file="file">
          <template v-if="ComputedListType === 'picture-card'">
            <img
              class="el-upload-list__item-thumbnail"
              :src="file.url"
              alt=""
            >
            <span class="el-upload-list__item-actions">
              <span
                class="el-upload-list__item-delete"
                @click="handleRemove(file)"
              >
                <i class="el-icon-delete" />
              </span>
            </span>
          </template>
          <template v-else>
            <div style="position: relative;padding: 4px 10px; display: flex; justify-content: space-between; align-items: center;">
              {{ file.name }}
              <span
                @click="handleRemove(file)"
              >
                <i class="el-icon-delete" />
              </span>
            </div>
          </template>
        </slot>
        <el-progress v-if="file.status === 'ready'" :type="ComputedListType === 'text' ? 'line' : 'circle'" :percentage="filePercentage[file.uid]" />
      </div>
    </el-upload>
  </div>
</template>

<script>
import { Message, Upload } from 'element-ui'
import axios from 'axios'
import uploadConfig from '@/components/WhUploader/uploadConfig'

export default {
  name: 'WhUploader',
  components: {
    ElUpload: Upload
  },
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false
      }
    },
    showFileList: {
      type: Boolean,
      default() {
        return this.limit > 1
      }
    },
    notPic: {
      type: Boolean,
      default() {
        return false
      }
    },
    isPrivate: {
      type: Boolean,
      default() {
        return false
      }
    },
    // 请求文件时的服务器地址，请求文件时会在其后拼接key
    hostAddr: {
      type: String,
      default() {
        return uploadConfig.fetchUrl
      }
    },
    // 默认上传地址, 只有在使用默认上传方法的时候才生效
    uploadAddr: {
      type: String,
      default() {
        return uploadConfig.uploadUrl
      }
    },
    axiosRequester: {
      type: [Object, Function],
      default() {
        return this.$genAxiosInstanceFn && this.$genAxiosInstanceFn.constructor === Function ? this.$genAxiosInstanceFn() : axios.create()
      }
    },
    limit: {
      type: Number,
      default() {
        return 99999
      }
    },
    validExt: {
      type: Array,
      default() {
        return ['jpg', 'jpeg', 'png']
      }
    },
    // 预设已存在的文件列表
    presetFileList: {
      type: Array,
      default() {
        return []
      }
    },
    // 额外的数据，会在上传文件的同时发送
    extraData: {
      type: Object,
      default() {
        return {}
      }
    }, /**
     * 改函数会在获取文件上传token之前被调用，返回的对象将会被作为获取文件上传token请求的参数, 默认参数为选择的文件
     **/
    generateGetUploadTokenParams: {
      type: Function,
      default(file) {
        return {}
      }
    },
    removeFileOnCloud: {
      type: Function,
      default(list) {
        // todo 默认删除已上传文件的方法
      }
    },
    uploadFileRequest: {
      type: Function,
      default(fileData, file) {
        // todo 添加默认请求方法
        return new Promise((resolve, reject) => {
          this.axiosRequester.request({
            url: this.uploadAddr,
            method: 'post',
            data: fileData,
            'Content-Type': 'multipart/form-data',
            withCredentials: false,
            onUploadProgress: progressEvent => {
              this.$set(this.filePercentage, file.file.uid, (progressEvent.loaded / progressEvent.total * 100 | 0))
            }
          }).then(res => {
            resolve(res)
          }).catch(err => {
            Message({
              type: 'warning',
              message: '上传失败:' + err
            })
            reject(err)
          })
        })
      }
    },
    // 文件上传请求发起前的回调
    beforeUploadRequestHandle: {
      type: Function,
      default(file) {
        return new Promise((resolve, reject) => {
          let url = '/get/file/token'
          const timeKey = new Date().getTime() + '_'
          if (this.isPrivate === true) {
            url = '/file_upload/private'
          }
          this.axiosRequester.request({
            url,
            params: {
              file_name: timeKey + file.file.name.replace(/[%,\[\]]/g, ''),
              ...this.generateGetUploadTokenParams(file)
            }
          }).then(res => {
            const fd = new FormData()
            fd.append('file', file.file)
            // fd.append('token', res.data.token)
            fd.append('key', timeKey + file.file.name.replace(/[%,\[\]]/g, ''))
            fd.append('token', res.data)
            resolve(fd)
          }).catch(err => {
            Message({
              type: 'warning',
              message: '获取token失败:' + err
            })
            reject(err)
          })
        })
      }
    },
    buildItemIntoList: {
      type: Function,
      default(res, file) {
        // todo 上传成功后，构造对象进入上传结果列表的方法
        return { ...res.data, name: res.data.key, url: this.hostAddr + '/' + res.data.key }
      }
    }
  },
  data() {
    return {
      fileListResult: [],
      deletedFileList: [],
      newUploadFileList: [],
      filePercentage: {},
      singleFileUpload: undefined
    }
  },
  computed: {
    ComputedListType() {
      if (this.limit > 1) {
        return this.notPic ? 'text' : 'picture-card'
      } else {
        return this.notPic ? 'text' : ''
      }
    },
    allFileUploadDone() {
      const fileLength = Object.keys(this.filePercentage).length
      if (fileLength > 0) {
        return Object.values(this.filePercentage).filter(i => {
          return i !== 100
        }).length === 0
      } else {
        return true
      }
    }
  },
  watch: {
    presetFileList: {
      handler(val, oldVal = []) {
        if (this.limit > 1) {
          const ret = val.filter(item => {
            return oldVal.findIndex(it => {
              return it.url === item.url
            }) === -1
          })
          if (ret.length > 0) {
            this.fileListResult = val
          }
        } else {
          if (this.limit === 1 && val.length > 0 && val[0] !== undefined) {
            if (val[0].constructor === Array || val[0].constructor === Object) {
              this.singleFileUpload = JSON.parse(JSON.stringify(val[0]))
              this.fileListResult = val
            }
          } else if (this.limit === 1 && val.length === 0) {
            this.singleFileUpload = undefined
            this.fileListResult = val
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    fileChangeHandle(file, fileList) {
      if (this.limit === 1) {
        const reader = new FileReader()
        reader.readAsDataURL(file.raw)
        reader.onload = (url) => {
          this.singleFileUpload = {
            ...file,
            url: url.currentTarget.result
          }
        }
      }
    },
    handleRemove(file, fileList) {
      this.deletedFileList.push(...this.fileListResult.filter(i => (i.url !== file.url || i.uid === file.uid)))
      this.fileListResult = this.fileListResult.filter(i => (i.uid !== file.uid || i.url !== file.url))
      this.listChangeEventTrigger()
      return true
    },
    beforeUploadHandle(file) {
      const extStr = file.name.split('.').pop().toLowerCase()
      const validExt = this.validExt

      if (validExt.findIndex((ext) => ext === extStr) === -1) {
        Message({
          message: '文件类型错误，仅允许' + validExt.join(',') + '的文件',
          type: 'warning'
        })
        return false
      }
      return true
    },
    onExceedHandle(files, fileList) {
      Message({
        message: '最多上传' + this.limit + '个文件',
        type: 'warning'
      })
    },
    uploadRequestHandle(file) {
      this.beforeUploadRequestHandle(file).then(retFile => {
        this.uploadFileRequest(retFile, file).then(res => {
          if (this.limit > 1) {
            this.fileListResult.push(this.buildItemIntoList(res, file))
            this.newUploadFileList.push(this.buildItemIntoList(res, file))
          } else {
            if (this.fileListResult.length > 0) {
              this.deletedFileList.push(this.fileListResult.pop())
            }
            this.fileListResult.push(this.buildItemIntoList(res, file))
          }
          this.listChangeEventTrigger()
        }).catch(_ => {
          if (this.limit <= 1) {
            this.$refs.uploader.clearFiles()
            this.listChangeEventTrigger()
          }
        })
      })
    },
    /**
     * 文件列表状态变化将会出发此函数，触发listChanged事件，事件参数为文件列表
     * @public
     **/
    listChangeEventTrigger() {
      this.$emit('listChanged', {
        deletedFileList: this.deletedFileList,
        newUploadFileList: this.newUploadFileList,
        fileListResult: this.fileListResult
      })
    },
    /**
     * 删除在清除队列的文件
     * @public
     **/
    clearDeleted() {
      if (this.deletedFileList.length > 0) {
        this.removeFileOnCloud(this.deletedFileList)
      }
    },
    /**
     * 删除新上传的文件列表
     * @public
     */
    clearNewUpload() {
      if (this.newUploadFileList.length > 0) {
        this.removeFileOnCloud(this.newUploadFileList)
      }
    }
  }
}
</script>

<style scoped lang="less">
  .el-upload-list__item-thumbnail{
    height: 100%;
    object-fit: cover;
  }
  .single-pic-show {
    position: relative;
    min-height: 90px;min-width: 120px;max-height: 120px;max-width: 160px;position:relative;border: 1px dashed #b6b6b6; color: #e6e6e6; padding: 2px;
    > img {
      width: 100%
    }
    > .trigger-icon-box {
      position: absolute; width: 100%;top: 0; left: 0; height: 100%;display: flex; align-items: center; justify-content: center;
    }
  }
  .uploader.exceed-limit {
    ::v-deep{
      .el-upload.el-upload--picture-card{
        display: none;
      }
    }
  }
  .uploader {
    ::v-deep{
      .el-upload-list--picture-card .el-upload-list__item {
        transform: none!important;
      }
    }
  }
</style>
